import { useGoogleLogin } from "@react-oauth/google";
import { useToast } from "../../hooks/use-toast";
import { useCallback } from "react";
import { Button } from "../ui/button";
import { BASE_URL, LINKDIN_AUTH_URL } from "../../lib/utils";

const GoogleIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 48 48">
		<path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303A11.994 11.994 0 0 1 12 24c0-6.627 5.373-12 12-12 3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C33.036 6.053 28.736 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.342-.138-2.651-.389-3.917z" />
		<path fill="#FF3D00" d="M6.306 14.691l6.571 4.819A11.959 11.959 0 0 1 12 24c0 2.09.546 4.053 1.504 5.762l-6.571 4.82A19.924 19.924 0 0 1 4 24c0-3.39.846-6.587 2.306-9.309z" />
		<path fill="#4CAF50" d="M24 44c4.736 0 9.036-2.053 12.059-5.382l-5.657-5.657C28.843 34.846 26.059 36 24 36c-5.146 0-9.514-3.266-11.163-7.838l-6.571 4.819C9.6 39.313 16.227 44 24 44z" />
		<path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303a12.08 12.08 0 0 1-4.245 5.961l.003-.002 5.657 5.657C38.929 36.34 44 31.005 44 24c0-1.342-.138-2.651-.389-3.917z" />
	</svg>
);
export const GitHubIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="20"
		height="20"
		viewBox="0 0 24 24"
		role="img"
		aria-label="GitHub"
		fill="currentColor"
	>
		<title>GitHub</title>
		<path d="M12 .5C5.73.5.86 5.37.86 11.64c0 4.84 3.14 8.95 7.5 10.4.55.1.75-.24.75-.53v-1.85c-3.05.66-3.7-1.41-3.7-1.41-.5-1.27-1.22-1.61-1.22-1.61-.99-.68.08-.67.08-.67 1.1.08 1.68 1.13 1.68 1.13.97 1.66 2.54 1.18 3.16.9.1-.7.38-1.18.68-1.45-2.43-.28-4.99-1.22-4.99-5.44 0-1.2.43-2.18 1.13-2.95-.11-.28-.49-1.4.11-2.92 0 0 .92-.3 3.02 1.13a10.4 10.4 0 0 1 2.75-.37c.93 0 1.86.12 2.74.37 2.09-1.43 3.01-1.13 3.01-1.13.6 1.52.22 2.64.11 2.92.71.77 1.12 1.75 1.12 2.95 0 4.23-2.57 5.15-5.02 5.42.39.34.73 1.02.73 2.06v3.05c0 .29.2.64.76.53 4.36-1.45 7.49-5.56 7.49-10.4C23.14 5.37 18.27.5 12 .5z" />
	</svg>
)
export const LinkedInIcon = ()=>(
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="20"
		height="20"
		viewBox="0 0 24 24"
		role="img"
		aria-label="GitHub"
		fill="currentColor"
	>
		<title>GitHub</title>
		<path d="M12 .5C5.73.5.86 5.37.86 11.64c0 4.84 3.14 8.95 7.5 10.4.55.1.75-.24.75-.53v-1.85c-3.05.66-3.7-1.41-3.7-1.41-.5-1.27-1.22-1.61-1.22-1.61-.99-.68.08-.67.08-.67 1.1.08 1.68 1.13 1.68 1.13.97 1.66 2.54 1.18 3.16.9.1-.7.38-1.18.68-1.45-2.43-.28-4.99-1.22-4.99-5.44 0-1.2.43-2.18 1.13-2.95-.11-.28-.49-1.4.11-2.92 0 0 .92-.3 3.02 1.13a10.4 10.4 0 0 1 2.75-.37c.93 0 1.86.12 2.74.37 2.09-1.43 3.01-1.13 3.01-1.13.6 1.52.22 2.64.11 2.92.71.77 1.12 1.75 1.12 2.95 0 4.23-2.57 5.15-5.02 5.42.39.34.73 1.02.73 2.06v3.05c0 .29.2.64.76.53 4.36-1.45 7.49-5.56 7.49-10.4C23.14 5.37 18.27.5 12 .5z" />
	</svg>
)
const SocialAuthButtons = ({
	allowGit,
	allowGoogle,
	allowLinkedIn = true,
	onGithub,
	onGoogle,
	isLoading = false,
}) => {
	const { toast } = useToast();
	const handleLinkdingLogin = useCallback(async() => {
		try{
			const params = new URLSearchParams({
				response_type:"code",
				client_id: process.env.REACT_APP_LINKEDIN_CLIENT_ID,
				redirect_uri: `${BASE_URL}/auth/linkedin/callback`,
				scope: "openid email profile",
			});
			window.location.href = `${LINKDIN_AUTH_URL}?${params.toString()}`;
		}catch(e){
			toast({
				title: "LinkedIn login failed",
				description: "Please try again.",
				variant: "destructive",
			});
		}
	}, []);
	const responseGoogle = useCallback(
		(authResult) => {
			try {
				if (authResult && authResult.access_token) {
					onGoogle?.(authResult.access_token);
				}
			} catch (error) {
				toast({
					title: "Google login failed",
					description: "Please try again.",
					variant: "destructive",
				});
			}
		},
		[onGoogle, toast]
	);

	const googleLogin = useGoogleLogin({
		onSuccess: responseGoogle,
		onError: responseGoogle,
		flow: "implicit",
	});

	if (!allowGit && !allowGoogle && !allowLinkedIn) return null;

	return (
		<div className="mt-4 rounded-2xl bg-secondary/40 p-3">
			<div className="flex flex-wrap gap-3 justify-between items-center rounded-lg">
				<Button
					type="button"
					variant="outline"
					loading={isLoading}
					className="w-full"
					leftIcon={
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="20"
							height="20"
							viewBox="0 0 24 24"
							role="img"
							aria-label="GitHub"
							fill="currentColor"
						>
							<title>GitHub</title>
							<path d="M12 .5C5.73.5.86 5.37.86 11.64c0 4.84 3.14 8.95 7.5 10.4.55.1.75-.24.75-.53v-1.85c-3.05.66-3.7-1.41-3.7-1.41-.5-1.27-1.22-1.61-1.22-1.61-.99-.68.08-.67.08-.67 1.1.08 1.68 1.13 1.68 1.13.97 1.66 2.54 1.18 3.16.9.1-.7.38-1.18.68-1.45-2.43-.28-4.99-1.22-4.99-5.44 0-1.2.43-2.18 1.13-2.95-.11-.28-.49-1.4.11-2.92 0 0 .92-.3 3.02 1.13a10.4 10.4 0 0 1 2.75-.37c.93 0 1.86.12 2.74.37 2.09-1.43 3.01-1.13 3.01-1.13.6 1.52.22 2.64.11 2.92.71.77 1.12 1.75 1.12 2.95 0 4.23-2.57 5.15-5.02 5.42.39.34.73 1.02.73 2.06v3.05c0 .29.2.64.76.53 4.36-1.45 7.49-5.56 7.49-10.4C23.14 5.37 18.27.5 12 .5z" />
						</svg>
					}
					disabled={!allowGit}
					onClick={allowGit ? onGithub : undefined}
				>
					GitHub
				</Button>

				<Button
					type="button"
					variant="outline"
					loading={isLoading}
					className="w-full"
					leftIcon={<GoogleIcon />}
					disabled={!allowGoogle}
					onClick={allowGoogle ? googleLogin : undefined}
				>
					Google
				</Button>

				<Button
					type="button"
					variant="outline"
					loading={isLoading}
					className="w-full"
					leftIcon={
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="20"
							height="20"
							viewBox="0 0 24 24"
							role="img"
							aria-label="LinkedIn"
							fill="currentColor"
						>
							<title>LinkedIn</title>
							<path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.447-2.136 2.941v5.665H9.351V9h3.414v1.561h.049c.476-.9 1.637-1.85 3.37-1.85 3.6 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 1 1 0-4.124 2.062 2.062 0 0 1 0 4.124zM7.119 20.452H3.554V9h3.565v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
						</svg>
					}
					disabled={!allowLinkedIn}
					onClick={allowLinkedIn ? handleLinkdingLogin : undefined}
				>
					LinkedIn
				</Button>
			</div>
		</div>
	);
};

export default SocialAuthButtons;